"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchers = void 0;
var ReportFileActions = require("@caddigital/sok-reducers/lib/actions/reports/file");
var ReportListActions = require("@caddigital/sok-reducers/lib/actions/reports/list");
var ToastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var mapDispatchers = function (dispatch) { return ({
    clearReportFile: function () { return dispatch(ReportFileActions.clearReportFile()); },
    fetchReportFile: function (uuid, fileName) {
        return dispatch(ReportFileActions.fetchReportFileRequest(uuid, fileName));
    },
    clearReportList: function () { return dispatch(ReportListActions.clearReportList()); },
    fetchReportList: function (customerId, type) { return dispatch(ReportListActions.fetchReportListRequest(customerId, type)); },
    showReportFileErrorToast: function (fileName) {
        var title = (0, translation_1.getLocalization)('management/reports/file/errorToast/title');
        dispatch(ToastActions.addNewToast(title, fileName, 'FAILURE'));
    }
}); };
exports.mapDispatchers = mapDispatchers;
